import image01 from "../assets/jpg/projects/avalog/preview.jpg";
import image02 from "../assets/jpg/projects/bring-me-home/preview.jpg";
import image03 from "../assets/jpg/projects/reconnect/preview.jpg";
import image04 from "../assets/jpg/projects/instar/preview.jpg";
import image05 from "../assets/jpg/projects/enter-dao/preview.jpg";
import image06 from "../assets/jpg/projects/despade/preview.jpg";

export const projectsList = [
  {
    title: "Avalog",
    subtitle: "Case study",
    type: "products",
    image: image01,
    titleDashCase: "avalog",
  },
  {
    title: "Bring me home",
    subtitle: "Case study",
    type: "products",
    image: image02,
    titleDashCase: "bring-me-home",
  },
  {
    title: "Reconnect",
    subtitle: "Web design",
    type: "web",
    image: image03,
    titleDashCase: "reconnect",
  },
  {
    title: "Instar.studio",
    subtitle: "Branding",
    type: "branding",
    image: image04,
    titleDashCase: "instar",
  },
  {
    title: "Enter Dao",
    subtitle: "Web UI",
    type: "web",
    image: image05,
    titleDashCase: "enter-dao",
  },
  {
    title: "Despade",
    subtitle: "Branding",
    type: "branding",
    image: image06,
    titleDashCase: "despade",
  },
];
